import styled from 'styled-components';
import { color } from '@magalu/stereo-ui-styles';
export const Rule = styled.hr`
  height: ${({
  size
}) => `${size}px`};
  width: 100%;
  border: none;
  ${color}
`;